import Client from './KomodoClient';

const list = () => Client.get('/api/department');
const tree = () => Client.get('/api/department/tree');

export default { list, tree };
